import type { CSSProperties } from 'react';
import { Body, Eyebrow, Headline, Img, Qr, Wordmark, arch, frame, sans, serif, type DesignProps } from './designParts';

/** Print (flyer, poster, visitekaartje, cadeaubon, nazorgkaart) en de nieuwsbriefkop. */

const rule = (color: string): CSSProperties => ({
  borderTop: `1px solid ${color}33`
});
export function FlyerDesign({
  d,
  p,
  w,
  h,
  city,
  contact
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: 48
  }} data-id="element-2982" data-mp="j17mxotg2j39">
      <div style={{
      ...arch(778),
      height: 470,
      flexShrink: 0
    }} data-id="element-2983" data-mp="j325iwh8tz46">
        <Img src={d.image} data-id="element-2984" data-mp="e9h9vb34hh85" />
      </div>
      <div style={{
      marginTop: 40,
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }} data-id="element-2985" data-mp="e8egmwibv2p2">
        <Eyebrow text={d.eyebrow} p={p} size={20} data-id="element-2986" data-mp="991t09jmtrlf" />
        <Headline d={d} p={p} size={62} data-id="element-2987" data-mp="4d4fsc3o11cv" />
        <Body text={d.body} p={p} size={20} maxWidth="92%" data-id="element-2988" data-mp="49yr2xyy81ho" />
      </div>
      {d.points.length > 0 && <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: '26px 0 0'
    }} data-id="element-2989" data-mp="3vk76z3ji77n3">
          {d.points.map((pt, i) => <li key={i} style={{
        ...rule(p.fg),
        padding: '13px 0',
        fontFamily: sans,
        fontSize: 19,
        color: p.fg,
        display: 'flex',
        gap: 16
      }} data-id="element-2990" data-mp="3jhjrufwecl8n" data-mpi={i}>
              <span style={{
          color: p.accent,
          fontFamily: serif,
          fontSize: 20,
          width: 16
        }} data-id="element-2991" data-mp="3o91s11qlihsk">{i + 1}</span>
              {pt}
            </li>)}
        </ul>}
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'flex-end',
      gap: 28,
      ...rule(p.fg),
      paddingTop: 24
    }} data-id="element-2992" data-mp="3ehxc9zt3iswo">
        <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-2993" data-mp="63ood51iqqau">
          <Wordmark size={28} color={p.fg} city={city} data-id="element-2994" data-mp="b2039u6o7qzx" />
          <div style={{
          fontFamily: sans,
          fontSize: 16,
          lineHeight: 1.5,
          color: p.fg
        }} data-id="element-2995" data-mp="azdvpujs5bhp">
            {contact.map(c => <div key={c} data-id="element-2996" data-mp="1312exs5cznh">{c}</div>)}
          </div>
          {d.cta && <div style={{
          fontFamily: sans,
          fontSize: 18,
          fontWeight: 500,
          color: p.fg
        }} data-id="element-2997" data-mp="15ewb3b3c5tg">{d.cta}</div>}
        </div>
        <Qr url={d.qrUrl} p={p} size={128} data-id="element-2998" data-mp="2ltjf1m9u00m6" />
      </div>
    </div>;
}
export function PosterDesign({
  d,
  p,
  w,
  h,
  city,
  product
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '64px 64px 56px'
  }} data-id="element-2999" data-mp="saapx5uc7sz9">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3000" data-mp="nd0r4zl264yr">
        <Eyebrow text={d.eyebrow} p={p} size={22} data-id="element-3001" data-mp="ik7nkf1bt2o9" />
        <Wordmark size={24} color={p.fg} city={city} sub="" data-id="element-3002" data-mp="iiwlcjnj42z9" />
      </div>
      <div style={{
      marginTop: 48
    }} data-id="element-3003" data-mp="dlmv51sbfnad">
        <Headline d={d} p={p} size={148} accentSize={46} data-id="element-3004" data-mp="9kkssc33qv46" />
      </div>
      <div style={{
      ...arch(420),
      background: p.soft,
      width: 420,
      height: 460,
      margin: '44px auto 0',
      padding: 48,
      flexShrink: 0
    }} data-id="element-3005" data-mp="9ihw597g23qh">
        <Img src={product?.image ?? ''} fit="contain" width={900} data-id="element-3006" data-mp="3vrj3vely28op" />
      </div>
      <div style={{
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'flex-end',
      gap: 32,
      ...rule(p.fg),
      paddingTop: 28
    }} data-id="element-3007" data-mp="3vtm40rgt9i75">
        <div style={{
        flex: 1
      }} data-id="element-3008" data-mp="1u0xygbgp2io7">
          <Body text={d.body} p={p} size={24} data-id="element-3009" data-mp="1tz4s6x9zu0gq" />
        </div>
        {d.qrUrl && <div style={{
        textAlign: 'center'
      }} data-id="element-3010" data-mp="1p2ea64emouso">
            <Qr url={d.qrUrl} p={p} size={120} data-id="element-3011" data-mp="1ozidejeioc5t" />
            <div style={{
          fontFamily: sans,
          fontSize: 14,
          color: p.fg,
          marginTop: 8
        }} data-id="element-3012" data-mp="1xhaky1smnz3i">Scan en bekijk</div>
          </div>}
      </div>
    </div>;
}
export function CardDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    flexDirection: 'row'
  }} data-id="element-3013" data-mp="26bffowavtuob">
      <div style={{
      width: '42%',
      background: p.soft,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: 28
    }} data-id="element-3014" data-mp="2b8p2e46vzs8g">
        <Wordmark size={26} color={p.fg} city={city} sub="" data-id="element-3015" data-mp="1ilcr4q66f6ug" />
        <div style={{
        fontFamily: serif,
        fontStyle: 'italic',
        fontSize: 15,
        color: p.accent,
        lineHeight: 1.3
      }} data-id="element-3016" data-mp="1njwdgroomknc">
          Eén cliënt tegelijk.
          <br data-id="element-3017" data-mp="1sh60k0olmk80" />
          Altijd door mij.
        </div>
      </div>
      <div style={{
      flex: 1,
      padding: '28px 28px 24px',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-3018" data-mp="2yyjeuknanes6">
        <div style={{
        fontFamily: serif,
        fontSize: 26,
        color: p.fg,
        lineHeight: 1.1
      }} data-id="element-3019" data-mp="33x4f2k2jpygm">{d.headline}</div>
        <div style={{
        fontFamily: sans,
        fontSize: 12,
        color: p.accent,
        marginTop: 6
      }} data-id="element-3020" data-mp="gqi5yoyr1lql">{d.body}</div>
        <div style={{
        marginTop: 'auto',
        display: 'flex',
        alignItems: 'flex-end',
        gap: 12
      }} data-id="element-3021" data-mp="bsgaf4k4zty8">
          <div style={{
          flex: 1,
          fontFamily: sans,
          fontSize: 11.5,
          lineHeight: 1.6,
          color: p.fg
        }} data-id="element-3022" data-mp="prg2ynarsszo">
            {d.points.map((pt, i) => <div key={i} data-id="element-3023" data-mp="zoufwcxhizn8" data-mpi={i}>{pt}</div>)}
          </div>
          <Qr url={d.qrUrl} p={p} size={58} data-id="element-3024" data-mp="zn9i8efvj0l5" />
        </div>
      </div>
    </div>;
}
export function GiftCardDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: 28
  }} data-id="element-3025" data-mp="18he8avn6o7zm">
      <div style={{
      flex: 1,
      border: `1px solid ${p.accent}`,
      display: 'flex',
      padding: 40,
      gap: 40
    }} data-id="element-3026" data-mp="18iz2gk5l5owy">
        <div style={{
        flex: 1.2,
        display: 'flex',
        flexDirection: 'column'
      }} data-id="element-3027" data-mp="14hx383bo5cuz">
          <Eyebrow text={d.eyebrow} p={p} size={18} data-id="element-3028" data-mp="1iflohc9nem0k" />
          <div style={{
          marginTop: 16
        }} data-id="element-3029" data-mp="1dh0kd1r9zi6u">
            <Headline d={d} p={p} size={110} accentSize={28} data-id="element-3030" data-mp="1di2743hnlt4e" />
          </div>
          <div style={{
          marginTop: 22
        }} data-id="element-3031" data-mp="1x3c6g3n8wnyp">
            <Body text={d.body} p={p} size={17} data-id="element-3032" data-mp="2213xywjza82d" />
          </div>
          <div style={{
          marginTop: 'auto'
        }} data-id="element-3033" data-mp="220lv3h2t8vlh">
            <Wordmark size={24} color={p.fg} city={city} data-id="element-3034" data-mp="1n43f7ijrlng1" />
          </div>
        </div>
        <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        background: p.soft,
        padding: '28px 28px 22px'
      }} data-id="element-3035" data-mp="1s2xy0khqfc05">
          {d.points.map((pt, i) => <div key={i} style={{
          marginTop: i === 0 ? 0 : 30
        }} data-id="element-3036" data-mp="1e9yl8q9c3vwa" data-mpi={i}>
              <div style={{
            fontFamily: sans,
            fontSize: 14,
            color: p.fg
          }} data-id="element-3037" data-mp="1j2hujb0zo4va">{pt}</div>
              <div style={{
            borderBottom: `1px solid ${p.fg}66`,
            height: 36
          }} data-id="element-3038" data-mp="14dvibi6nrt8a" />
            </div>)}
          <div style={{
          marginTop: 'auto',
          fontFamily: sans,
          fontSize: 12.5,
          lineHeight: 1.5,
          color: p.fg
        }} data-id="element-3039" data-mp="19bn9g9zhbbbf">{d.cta}</div>
        </div>
      </div>
    </div>;
}
export function AftercareDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    padding: '48px 48px 40px'
  }} data-id="element-3040" data-mp="zdh6rq5um15i">
      <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline'
    }} data-id="element-3041" data-mp="321z9zfo4xx0r">
        <Eyebrow text={d.eyebrow} p={p} size={17} data-id="element-3042" data-mp="2x966ev4ekuq9" />
        <Wordmark size={20} color={p.fg} city={city} sub="" data-id="element-3043" data-mp="2x8edxt63rd47" />
      </div>
      <div style={{
      marginTop: 36
    }} data-id="element-3044" data-mp="2sbe55ahvbw9e">
        <Headline d={d} p={p} size={56} data-id="element-3045" data-mp="2ncb9ggns32e3" />
      </div>
      <ul style={{
      listStyle: 'none',
      padding: 0,
      margin: '32px 0 0'
    }} data-id="element-3046" data-mp="2ndmeejsymg6s">
        {d.points.map((pt, i) => <li key={i} style={{
        ...rule(p.fg),
        padding: '14px 0',
        display: 'flex',
        gap: 14,
        alignItems: 'baseline',
        fontFamily: sans,
        fontSize: 17,
        color: p.fg,
        lineHeight: 1.4
      }} data-id="element-3047" data-mp="3kz0g53tfe36a" data-mpi={i}>
            <span style={{
          width: 8,
          height: 8,
          borderRadius: 99,
          background: p.accent,
          flexShrink: 0,
          transform: 'translateY(-2px)'
        }} data-id="element-3048" data-mp="3b3gr91da44r1" />
            {pt}
          </li>)}
      </ul>
      {d.body && <div style={{
      marginTop: 24,
      background: p.soft,
      padding: '18px 22px',
      borderRadius: 12
    }} data-id="element-3049" data-mp="1vkvenzc2i9cs">
          <Body text={d.body} p={p} size={16} data-id="element-3050" data-mp="b2t61rz83cj4" />
        </div>}
      {d.cta && <div style={{
      marginTop: 'auto'
    }} data-id="element-3051" data-mp="b100yh49d0d8">
          <div style={{
        fontFamily: sans,
        fontSize: 14,
        color: p.fg
      }} data-id="element-3052" data-mp="f5g62g61s3re">{d.cta}</div>
          <div style={{
        borderBottom: `1px solid ${p.fg}66`,
        height: 34
      }} data-id="element-3053" data-mp="k2zlvkie8olg" />
        </div>}
    </div>;
}
export function EmailDesign({
  d,
  p,
  w,
  h,
  city
}: DesignProps) {
  return <div style={{
    ...frame(w, h, p.bg),
    flexDirection: 'row'
  }} data-id="element-3054" data-mp="ttknlgtd698l">
      <div style={{
      flex: 1.15,
      padding: '56px 64px',
      display: 'flex',
      flexDirection: 'column'
    }} data-id="element-3055" data-mp="tvezk5mnqr0j">
        <Wordmark size={26} color={p.fg} city={city} sub="" data-id="element-3056" data-mp="yui6jvm777b5" />
        <div style={{
        marginTop: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 18
      }} data-id="element-3057" data-mp="12v20yrfdzwtl">
          <Eyebrow text={d.eyebrow} p={p} size={22} data-id="element-3058" data-mp="17s0x1fim2duf" />
          <Headline d={d} p={p} size={68} data-id="element-3059" data-mp="34ldj4eqz7ts3" />
        </div>
      </div>
      <div style={{
      flex: 1,
      padding: '40px 40px 0 0'
    }} data-id="element-3060" data-mp="34n6rbyh8mm27">
        <div style={{
        ...arch(520),
        height: '100%'
      }} data-id="element-3061" data-mp="39jneoqgm4we8">
          <Img src={d.image} data-id="element-3062" data-mp="39mjeylfxnx5u" />
        </div>
      </div>
    </div>;
}